import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchEditsHistory, fetchTemplate} from '../thunks';
import {
    Grid,
    Paper,
    Typography,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
} from 'material-ui';
import {splitAndShowLocalDateTime} from '../../../components/helpers/helpers';
import {BackButton} from '../../../components/buttons/BackButton';
import ScrollToTop from '../../../components/scroll-top/ScrollToTop';

class EditsHistory extends Component {

    componentWillMount() {
        this.props.fetchEditsHistory(this.props.template.id);
        this.props.fetchTemplate(this.props.template.id);
    }

    render() {
        const {
            editsHistory,
            template,
            classes,
            loading
        } = this.props;

        return (
            loading === false &&
            <Grid item xs={12}>
                <Paper elevation={2} className={classes.marginBottom10}>
                    <Typography variant="subheading" className={classes.headingTitle}>Edits History for: {template.template}</Typography>
                </Paper>
                <Paper elevation={2} className={classes.marginBottom10}>
                    {editsHistory.length === 0 ? 
                    <Typography 
                        variant="subheading"
                        align='center'
                        className={classes.headingTitle}
                    >
                        No changes have been made on this template
                    </Typography>
                    :
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow className={classes.headerLabels}>
                                <TableCell width={100} className={classes.tableCell}>ID</TableCell>
                                <TableCell className={classes.tableCell}>Date modified</TableCell>
                                <TableCell width={100} className={classes.tableCell}>Success</TableCell>
                                <TableCell width={100} className={classes.tableCell}>Errors</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {editsHistory.map((history, index) => 
                                <TableRow hover={true} key={index}>
                                    <TableCell className={classes.tableCell}>{history.id}</TableCell>
                                    <TableCell className={classes.tableCell}>{splitAndShowLocalDateTime(history.created_at)}</TableCell>
                                    <TableCell className={classes.tableCell}>{history.count_successful}</TableCell>
                                    <TableCell className={classes.tableCell}>{history.count_errors}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    }
                </Paper>
                <Grid container spacing={16}>
                    <Grid item xs={12} className={classes.backButton}>
                        <BackButton
                            link={"/templates"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
                <ScrollToTop />
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    editsHistory: state.template.editsHistory,
});

export default connect(mapStateToProps, {
        fetchEditsHistory,
        fetchTemplate
})(EditsHistory);


// WEBPACK FOOTER //
// ./src/containers/templates/builder/EditsHistory.jsx